import routes from './routes';
import { SetRoutes } from 'components';

const LogsPage = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default LogsPage;
